class BESSAppAuthSection extends BESSAppBase {

    constructor() {
        super();
        this.loginPage = new BESSAppLogin();
        this.resetPassword = new BESSAppResetPassword();
        this.registerPage = new BESSAppRegister();
        this.accountSettingsPage = new BESSAppAccountSettings();
        this.councilSettingsPage = new BESSAppCouncilSettings();
    }
}